// extracted by mini-css-extract-plugin
export default {"Container":"igbYcbvD_g5qWHVBHZYJ"};